import styled from "styled-components";

export const Container = styled.div`
  & .slick-slider {
    .slick-dots {
      display: flex !important;
      justify-content: space-between;
      position: initial !important;
      margin-top: 10px;
      height: 100px;
      li {
        width: 130px;
        margin: 0;
      }
    }
  }
`;
